import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import _ from "lodash"

import { Button, CheckboxField, CalendarField, DropDownField, TextInputField } from "../../../../helpers";
import { Tooltip } from "primereact/tooltip";

import Loading from "../../../../common/Loading";

import { getFullName, getMaterialMasterDetailsTooltip } from '../../../../utils';
import { getPMCompanyConfig } from '../../../../setup/pmCompanyConfig';

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";

import "../index.css"

const todayDate = new Date()
const tomorrowDate = new Date()
tomorrowDate.setDate(tomorrowDate.getDate() + 1)


const FollowUpSellerPOItems = (props) => {
    const { followUpSellerPOItems, followUpSPOItemsMaterialDetails, selectedFollowUpSPOItems } = props

    const [bulkUpdateFollowUpSPOItemIds, setBulkUpdateFollowUpSPOItemIds] = useState([])
    const [formErrors, setFormErrors] = useState([])

    const followUpStatus = useSelector(state => state.common.followUpStatus)
    const userDetails = useSelector(state => state.userDetails)
    const materialBrands = useSelector(state => state.common.materialBrands)
    const isDocNoSearch = useSelector(state => state.followUp.isDocNoSearch)

    const PMCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)


    const dispatch = useDispatch()

    const handleOnClickSubmit = async () => {
        let relatedFollowUpSPOItems = selectedFollowUpSPOItems.filter(eachFollowUpSPOItem => eachFollowUpSPOItem.isEditable && (eachFollowUpSPOItem.followUpStatusId || eachFollowUpSPOItem.followUpDate || eachFollowUpSPOItem.remarks))

        if (relatedFollowUpSPOItems.length === 0) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please fill the details for atleast 1 item', life: 3000 }))
        }

        const { userNameDetails } = userDetails

        let validFollowUpSPOItems = []
        let invalidFollowUpSPOItems = []
        relatedFollowUpSPOItems.forEach(eachFollowUpSPOItem => {

            let followUpSPOItemCopy = { ...eachFollowUpSPOItem, updatedClientDelDateStatus: false }

            if (!followUpSPOItemCopy.expectedPMDeliveryDate) {
                invalidFollowUpSPOItems.push(followUpSPOItemCopy.materialId)
                dispatch(raiseToast({
                    severity: 'warn',
                    detail: `Please select expected delivery date for materialId ${followUpSPOItemCopy.materialId}`,
                    life: 3000
                }))
                return
            } else if(followUpSPOItemCopy.expectedPMDeliveryDate < new Date()){
                dispatch(raiseToast({
                    severity: 'warn',
                    detail: `Updated PM delivery date can't be previous date. Please select proper date to select followup status for materialId ${followUpSPOItemCopy.materialId}`,
                    life: 3000
                }))
                return
            } else {
                let expectedPMDeliveryDate = followUpSPOItemCopy.expectedPMDeliveryDate.setHours(0, 0, 0, 0)
                let prevUpdatedPMDeliveryDate = new Date(followUpSPOItemCopy.updatedPMDeliveryDate).setHours(0, 0, 0, 0)
                if (!followUpSPOItemCopy.updatedPMDeliveryDate || (expectedPMDeliveryDate > prevUpdatedPMDeliveryDate)) {
                    followUpSPOItemCopy.updatedClientDelDateStatus = true
                }

                followUpSPOItemCopy.expectedPMDeliveryDate = moment(new Date(followUpSPOItemCopy.expectedPMDeliveryDate)).format("YYYY-MM-DD")

            }

            if (!followUpSPOItemCopy.followUpStatusId) {
                invalidFollowUpSPOItems.push(followUpSPOItemCopy.materialId)
                dispatch(raiseToast({
                    severity: 'warn',
                    detail: `Please select followup status for materialId ${followUpSPOItemCopy.materialId}`,
                    life: 3000
                }))
                return
            }

            if (!followUpSPOItemCopy.followUpDate && followUpSPOItemCopy.followUpStatusId !== 6) {
                invalidFollowUpSPOItems.push(followUpSPOItemCopy.materialId)
                dispatch(raiseToast({
                    severity: 'warn',
                    detail: `Please select followup date for materialId ${followUpSPOItemCopy.materialId}`,
                    life: 3000
                }))
                return
            } else {
                if (followUpSPOItemCopy.followUpStatusId === 6) {
                    let relatedFollowUpSPOItem = followUpSellerPOItems.find(eachSPO => eachSPO.sellerPOItemId === followUpSPOItemCopy.sellerPOItemId)
                    if (relatedFollowUpSPOItem) {
                        followUpSPOItemCopy.followUpDate = relatedFollowUpSPOItem.followUpDate
                    }
                } else {
                    followUpSPOItemCopy.followUpDate = moment(new Date(followUpSPOItemCopy.followUpDate)).format("YYYY-MM-DD")
                }
            }

            if (!followUpSPOItemCopy.remarks || (followUpSPOItemCopy.remarks && !followUpSPOItemCopy.remarks.trim())) {
                invalidFollowUpSPOItems.push(followUpSPOItemCopy.materialId)
                dispatch(raiseToast({
                    severity: 'warn',
                    detail: `Enter follow up remarks for materialId ${followUpSPOItemCopy.materialId}`,
                    life: 3000
                }))
                return
            } else {
                followUpSPOItemCopy.remarks = followUpSPOItemCopy.remarks.trim()
                followUpSPOItemCopy.followUpRemarksDate = moment(new Date()).format("YYYY-MM-DD")

                if (followUpSPOItemCopy.followUpStatusId === 5 && followUpSPOItemCopy.expectedPMDeliveryDate) {
                    let expectedPMDeliveryDate = new Date(followUpSPOItemCopy.expectedPMDeliveryDate)
                    followUpSPOItemCopy.remarks += `.\nUpdated delivery date now is ${expectedPMDeliveryDate.getDate()}-${expectedPMDeliveryDate.getMonth() + 1}-${expectedPMDeliveryDate.getFullYear()} - follow up by ${getFullName(userNameDetails?.firstName, userNameDetails?.lastName)}`
                } else {
                    followUpSPOItemCopy.remarks += ` - follow up by ${getFullName(userNameDetails?.firstName, userNameDetails?.lastName)}`
                }
            }

            validFollowUpSPOItems.push(followUpSPOItemCopy)
        })

        if (invalidFollowUpSPOItems.length > 0) {
            return false
        }



        props.handleUpdateFollowUpDetails(validFollowUpSPOItems)

    }

    const handleBulkItemsInputChange = (e, name) => {
        let errorFollowUpSPOItems = []
        const updatedFollowUpSPOItems = selectedFollowUpSPOItems.map(eachSellerPOItem => {
            if (bulkUpdateFollowUpSPOItemIds.includes(eachSellerPOItem.sellerPOItemId)) {
                eachSellerPOItem[e.target.name] = e.target.value
                if (e.target.name === 'expectedPMDeliveryDate') {
                    let currentDate = new Date()
                    let selectedExpectedPMDeliveryDate = new Date(e.target.value)
                    let differenceInMilliseconds = selectedExpectedPMDeliveryDate - currentDate
                    let differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24))
                    let maximumFollowUpDate = null
                    if (differenceInDays > 0) {
                        if (differenceInDays >= 1 && differenceInDays <= 5) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate
                        } else if (differenceInDays >= 5 && differenceInDays <= 15) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 3)
                        } else if (differenceInDays >= 16 && differenceInDays <= 25) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 9)
                        } else if (differenceInDays >= 25) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 14)
                        }
                    }
                    eachSellerPOItem.maxFollowUpDate = new Date(maximumFollowUpDate)
                    eachSellerPOItem.followUpDate = new Date(maximumFollowUpDate)

                    if (eachSellerPOItem.expectedPMDeliveryDate.setHours(0, 0, 0, 0) > new Date(eachSellerPOItem.origExpectedPMDeliveryDate).setHours(0, 0, 0, 0)) {
                        eachSellerPOItem.followUpStatusId = 5
                    } else {
                        eachSellerPOItem.followUpStatusId = 4
                    }
                } else if (e.target.name === "followUpStatusId") {
                    if(eachSellerPOItem.expectedPMDeliveryDate < new Date()){
                        errorFollowUpSPOItems.push(eachSellerPOItem)
                    }else{
                        if([2].includes(e.target.value)){
                            eachSellerPOItem.followUpDate = new Date()
                        }else if ([3, 8].includes(e.target.value)) {
                            eachSellerPOItem.followUpDate = eachSellerPOItem.expectedPMDeliveryDate
                        }else if([6,7].includes(e.target.value)){
                            eachSellerPOItem.followUpDate = null
                        }else{
                            if(eachSellerPOItem.maxFollowUpDate){
                                eachSellerPOItem.followUpDate = eachSellerPOItem.maxFollowUpDate
                            }
                        }
                    }
                }
            }

            return eachSellerPOItem
        })

        if(errorFollowUpSPOItems.length){
            let relatedMaterialIds = _.uniqBy(errorFollowUpSPOItems, 'materialId').map(obj => obj.materialId)        
            dispatch(raiseToast({ severity: 'warn', detail: `Updated PM delivery date can't be previous date. Please select proper date to select followup status for ${relatedMaterialIds.join(", ")}`, life: 3000 }))
            return false
        }

        props.setSelectedFollowUpSPOItems([...updatedFollowUpSPOItems])

    }

    const handleInputChange = async (e, selectedFollowUpSPOItemId) => {

        if (bulkUpdateFollowUpSPOItemIds.includes(selectedFollowUpSPOItemId)) {
            handleBulkItemsInputChange(e)
        } else {
            let isSelectedFollowUpSPOItemFound = true
            let relatedSellerPOItem = selectedFollowUpSPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === selectedFollowUpSPOItemId)
            if (!relatedSellerPOItem) {
                let relatedFollowUpSPOItem = followUpSellerPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === selectedFollowUpSPOItemId)
                let followUpSPOItem = {
                    sellerPOItemId: relatedFollowUpSPOItem.sellerPOItemId,
                    materialId: relatedFollowUpSPOItem.materialId,
                    userId: relatedFollowUpSPOItem["sellerPO.createdBy"],
                    companyId: relatedFollowUpSPOItem["sellerPO.companyId"],
                    origExpectedPMDeliveryDate: relatedFollowUpSPOItem.origExpectedPMDeliveryDate,
                    expectedPMDeliveryDate: relatedFollowUpSPOItem.updatedPMDeliveryDate ? new Date(relatedFollowUpSPOItem.updatedPMDeliveryDate) : null,
                    maxFollowUpDate: null,
                    followUpDate: null,
                    followUpStatusId: null,
                    remarks: "",
                    createdBy: relatedFollowUpSPOItem.createdBy
                }

                if(relatedFollowUpSPOItem.followUpStatusId === 18 || (parseFloat(relatedFollowUpSPOItem.pendingQty) === 0 && (parseFloat(relatedFollowUpSPOItem.docQty) === parseFloat(relatedFollowUpSPOItem.dispatchedQty)))){
                    followUpSPOItem.followUpStatusId = relatedFollowUpSPOItem.followUpStatusId
                    followUpSPOItem.isEditable = false
                }

                isSelectedFollowUpSPOItemFound = false
                relatedSellerPOItem = followUpSPOItem
            }

            if (relatedSellerPOItem) {
                relatedSellerPOItem[e.target.name] = e.target.value
                if (e.target.name === 'expectedPMDeliveryDate') {
                    let currentDate = new Date()
                    let selectedExpectedPMDeliveryDate = new Date(e.target.value)
                    let differenceInMilliseconds = selectedExpectedPMDeliveryDate - currentDate
                    let differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24))
                    let maximumFollowUpDate = null
                    if (differenceInDays > 0) {
                        if (differenceInDays >= 1 && differenceInDays <= 5) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate
                        } else if (differenceInDays >= 5 && differenceInDays <= 15) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 3)
                        } else if (differenceInDays >= 16 && differenceInDays <= 25) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 9)
                        } else if (differenceInDays >= 25) {
                            maximumFollowUpDate = selectedExpectedPMDeliveryDate.setDate(selectedExpectedPMDeliveryDate.getDate() - 14)
                        }
                    }
                    relatedSellerPOItem.maxFollowUpDate = new Date(maximumFollowUpDate)
                    relatedSellerPOItem.followUpDate = new Date(maximumFollowUpDate)

                    if (relatedSellerPOItem.expectedPMDeliveryDate.setHours(0, 0, 0, 0) > new Date(relatedSellerPOItem.origExpectedPMDeliveryDate).setHours(0, 0, 0, 0)) {
                        relatedSellerPOItem.followUpStatusId = 5
                    } else {
                        relatedSellerPOItem.followUpStatusId = 4
                    }

                } else if (e.target.name === "followUpStatusId") {
                    if(relatedSellerPOItem.expectedPMDeliveryDate < new Date()){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Updated PM delivery date can't be previous date. Please select proper date to select followup status", life: 3000 }))
                    }
                    if([2].includes(e.target.value)){
                        relatedSellerPOItem.followUpDate = new Date()
                    }else if ([3, 8].includes(e.target.value)) {
                        relatedSellerPOItem.followUpDate = relatedSellerPOItem.expectedPMDeliveryDate
                    }else if([6,7].includes(e.target.value)){
                        relatedSellerPOItem.followUpDate = null
                    }else{
                        if(relatedSellerPOItem.maxFollowUpDate){
                            relatedSellerPOItem.followUpDate = relatedSellerPOItem.maxFollowUpDate
                        }
                    }
                }

                if (!isSelectedFollowUpSPOItemFound) {
                    props.setSelectedFollowUpSPOItems([...selectedFollowUpSPOItems, relatedSellerPOItem])
                } else {
                    props.setSelectedFollowUpSPOItems([...selectedFollowUpSPOItems])
                }
            }
        }
    }

    const handleSelectAllCheckBox = (event) => {
        let sellerPOItemIds = []
        let relatedSellerPOItems = []
        if (event.target.checked) {
            relatedSellerPOItems = selectedFollowUpSPOItems.filter(eachSellerPOItem => !bulkUpdateFollowUpSPOItemIds.includes(eachSellerPOItem.sellerPOItemId) && eachSellerPOItem.isEditable)
            if (relatedSellerPOItems.length > 0) {
                sellerPOItemIds = _.uniqBy(relatedSellerPOItems, 'sellerPOItemId').map(obj => obj.sellerPOItemId)        
            }
            setBulkUpdateFollowUpSPOItemIds([...bulkUpdateFollowUpSPOItemIds, ...sellerPOItemIds])
        }else{
            setBulkUpdateFollowUpSPOItemIds([])
        }
    }

    const handleSelectSellerPOItem = (event, selectedSellerPOItem, selectedSellerPOItemId) => {

        let relatedSellerPOItem = selectedFollowUpSPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === selectedSellerPOItem.sellerPOItemId)
        if (!relatedSellerPOItem) {
            let followUpSPOItem = {
                sellerPOItemId: selectedSellerPOItem.sellerPOItemId,
                materialId: selectedSellerPOItem.materialId,
                userId: selectedSellerPOItem.sPOcreatedBy,
                companyId: selectedSellerPOItem.sPOcompanyId,
                origExpectedPMDeliveryDate: selectedSellerPOItem.origExpectedPMDeliveryDate,
                expectedPMDeliveryDate: selectedSellerPOItem.updatedPMDeliveryDate ? new Date(selectedSellerPOItem.updatedPMDeliveryDate) : null,
                maxFollowUpDate: null,
                followUpDate: null,
                followUpStatusId: null,
                remarks: "",
                createdBy: selectedSellerPOItem.createdBy
            }
        
            if(selectedSellerPOItem.followUpStatusId === 18 || (parseFloat(selectedSellerPOItem.pendingQty) === 0 && (parseFloat(selectedSellerPOItem.docQty) !== parseFloat(selectedSellerPOItem.dispatchedQty)))){
                followUpSPOItem.followUpStatusId = selectedSellerPOItem.followUpStatusId
                followUpSPOItem.isEditable = false
            }

            props.setSelectedFollowUpSPOItems([...selectedFollowUpSPOItems, followUpSPOItem])
        }

        let relatedSellerPOItems = []
        if (bulkUpdateFollowUpSPOItemIds.includes(selectedSellerPOItemId)) {
            relatedSellerPOItems = bulkUpdateFollowUpSPOItemIds.filter(eachSellerPOItemId => eachSellerPOItemId !== selectedSellerPOItemId)
        }
        else {
            relatedSellerPOItems = [...bulkUpdateFollowUpSPOItemIds, selectedSellerPOItemId]
        }
        setBulkUpdateFollowUpSPOItemIds(relatedSellerPOItems)

    }

    const renderFollowUpSPOItems = (dayWisefollowUpSPOItems) => {
        return dayWisefollowUpSPOItems.map((eachSellerPOItem, index) => {

            let relatedMaterialItem = followUpSPOItemsMaterialDetails.find(eachMaterial => eachMaterial.buyerReqItemId === eachSellerPOItem.buyerReqItemId)

            const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterialItem?.brandId)
            const materialToolTip = getMaterialMasterDetailsTooltip({ ...relatedMaterialItem, ...relatedMaterialBrand })

            let relatedFollowUpSPOItem = selectedFollowUpSPOItems.find(eachFollowUpSPOItem => eachFollowUpSPOItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId)

            let isDisableFollowUpDate = relatedFollowUpSPOItem?.expectedPMDeliveryDate && [2,3,6,8,11,14,15].includes(relatedFollowUpSPOItem?.followUpStatusId)

            let sellerPOIncoTermId = null
            if (eachSellerPOItem.incoTermId) {
                sellerPOIncoTermId = eachSellerPOItem.incoTermId
            }

            let excludeFollowUpStatusIds = [1,9,10,11,14,15,18]

            let currentFollowUpStatus = ""
            if(relatedFollowUpSPOItem?.currentFollowUpStatusId){
                currentFollowUpStatus = followUpStatus.find(eachFollowUpStatus => eachFollowUpStatus.followUpStatusId === relatedFollowUpSPOItem.currentFollowUpStatusId)
                if(currentFollowUpStatus && currentFollowUpStatus.followUpStatusId !== 10){
                    excludeFollowUpStatusIds.push(12,13)
                }
            }

            if([1,2].includes(sellerPOIncoTermId)){
                excludeFollowUpStatusIds.push(2)
            }

            if(sellerPOIncoTermId === 3){
                excludeFollowUpStatusIds.push(3)
            }

            if (relatedFollowUpSPOItem?.expectedPMDeliveryDate?.setHours(0, 0, 0, 0) > new Date(relatedFollowUpSPOItem?.origExpectedPMDeliveryDate)?.setHours(0, 0, 0, 0)) {
                excludeFollowUpStatusIds.push(4)
            } else {
                excludeFollowUpStatusIds.push(5)
            }

            let relatedFollowUpStatus = followUpStatus.filter(eachFollowUpStatus => !excludeFollowUpStatusIds.includes(eachFollowUpStatus.followUpStatusId))

            return (
                <>
                    <div className="flex justify-content-between flex-grow-1 w-full data-style py-1" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "12px" }} key={`sellerPOItems-${eachSellerPOItem.sellerPOItemId}-${index}`}>
                        <>
                        <div className={`p-1 align-self-center mr-1 custom-tooltip-sellerpo-email-sent-${eachSellerPOItem.sellerPOItemId}`} style={{ width: '2%' }}>
                            <CheckboxField
                                className="col"
                                onChange={(e) => handleSelectSellerPOItem(e, eachSellerPOItem, eachSellerPOItem.sellerPOItemId)}
                                checked={bulkUpdateFollowUpSPOItemIds.includes(eachSellerPOItem.sellerPOItemId)}
                                disabled={!relatedFollowUpSPOItem?.isEditable}
                            />
                            {
                                !eachSellerPOItem.emailSent && PMCompanyConfig.isPOMailSentRequiredForFollowUp && <Tooltip target={`.custom-tooltip-sellerpo-email-sent-${eachSellerPOItem.sellerPOItemId}`} position="top" autoHide>
                                    <p className="m-0 mb-1">Can't do followup until email sent to seller</p>
                                </Tooltip>
                            }
                        </div>
                        </>
                        <div className="p-1 align-self-center" style={{ width: '14%', fontSize: "12px" }}>
                            {props.getSellerPODocNoBody(eachSellerPOItem)}
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '14%' }}>
                            <div className={`text-center custom-tool-tip-product-${eachSellerPOItem.sellerPOItemId}`}>
                                <div className='flex flex-row justify-content-center'>
                                    {relatedMaterialItem?.materialId} - {relatedMaterialBrand?.brandName}
                                </div>
                                <div className="date-string">{relatedMaterialItem?.productName} - {relatedMaterialItem?.variantName}</div>
                            </div>
                            <Tooltip target={`.custom-tool-tip-product-${eachSellerPOItem.sellerPOItemId}`} position="top" autoHide={true}>
                                <p className="m-0">{materialToolTip}</p>
                            </Tooltip>
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '8%' }}>
                            {props.getQtyBody(eachSellerPOItem)}
                            {/* {eachSellerPOItem.qty} */}
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '10%' }}>
                            {props.getBuyerCompanyName(eachSellerPOItem)}
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '7%' }}>
                            {props.getBuyerDeliveryDateBody(eachSellerPOItem)}
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '7%' }}>
                            {props.getPMDeliveryDateBody(eachSellerPOItem)}
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '7%' }}>
                            {props.getRemarksBody(eachSellerPOItem)}
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '7%' }}>
                            <CalendarField name="expectedPMDeliveryDate" labelText="" value={relatedFollowUpSPOItem?.expectedPMDeliveryDate} minDate={new Date()} onChange={(e) => handleInputChange(e, eachSellerPOItem.sellerPOItemId)} disabled={!relatedFollowUpSPOItem?.isEditable} dateFormat='dd/mm/y' errorMessage={formErrors[`[${index}]`]?.expectedPMDeliveryDate} />
                        </div>
                        <div className={`p-1 align-self-center ${currentFollowUpStatus ? "input-field-margin" : "mt-0"}`}style={{ width: '10%' }}>
                            <DropDownField name="followUpStatusId" labelText="" options={relatedFollowUpStatus} optionLabel="followUpStatusName" optionValue="followUpStatusId" value={relatedFollowUpSPOItem?.followUpStatusId} onChange={(e) => handleInputChange(e, eachSellerPOItem.sellerPOItemId)} disabled={!relatedFollowUpSPOItem?.isEditable} errorMessage={formErrors[`[${index}]`]?.followUpStatusId} />
                            {
                                currentFollowUpStatus ?
                                    <div className='m-0' style={{ fontSize: "10px" }}>
                                        <span>Cur Status: <br/><span style={{ fontWeight: "bold" }}>{currentFollowUpStatus.followUpStatusName}</span></span>
                                    </div> : null
                            }
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '7%' }}>
                            <CalendarField name="followUpDate" labelText="" value={relatedFollowUpSPOItem?.followUpDate} minDate={tomorrowDate} maxDate={relatedFollowUpSPOItem?.maxFollowUpDate} onChange={(e) => handleInputChange(e, eachSellerPOItem.sellerPOItemId)} dateFormat='dd/mm/y' disabled={!relatedFollowUpSPOItem?.isEditable} errorMessage={formErrors[`[${index}]`]?.followUpDate} />
                        </div>
                        <div className="p-1 align-self-center" style={{ width: '13%' }}>
                            <TextInputField name="remarks" labelText="" value={relatedFollowUpSPOItem?.remarks} onChange={(e) => handleInputChange(e, eachSellerPOItem.sellerPOItemId)} disabled={!relatedFollowUpSPOItem?.isEditable} errorMessage={formErrors[`[${index}]`]?.remarks} />
                        </div>
                    </div>
                </>
            )
        })
    }

    const todayFollowUpSPOItems = followUpSellerPOItems.filter(eachFollowUpSPOItem => {
        return eachFollowUpSPOItem.followUpDate && new Date(eachFollowUpSPOItem?.followUpDate)?.setHours(0, 0, 0, 0) === todayDate.setHours(0, 0, 0, 0)
    })

    const tomorrowFollowUpSPOItems = followUpSellerPOItems.filter(eachFollowUpSPOItem => {
        return eachFollowUpSPOItem.followUpDate && new Date(eachFollowUpSPOItem?.followUpDate)?.setHours(0, 0, 0, 0) === tomorrowDate.setHours(0, 0, 0, 0)
    })

    const otherFollowUpSPOItems = followUpSellerPOItems.filter(eachFollowUpSPOItem => {
        if (eachFollowUpSPOItem.followUpDate) {
            return new Date(eachFollowUpSPOItem?.followUpDate)?.setHours(0, 0, 0, 0) !== todayDate.setHours(0, 0, 0, 0) && new Date(eachFollowUpSPOItem?.followUpDate)?.setHours(0, 0, 0, 0) !== tomorrowDate.setHours(0, 0, 0, 0)
        }
    })

    let relatedFollowUpSPOItems = selectedFollowUpSPOItems.filter(eachFollowUpSPOItem => eachFollowUpSPOItem.isEditable)
    
    return (
        <div>
            {
                (todayFollowUpSPOItems.length + tomorrowFollowUpSPOItems.length + otherFollowUpSPOItems.length) ?
                    <>
                        <p className="my-1">{`There are these ${todayFollowUpSPOItems.length + tomorrowFollowUpSPOItems.length + otherFollowUpSPOItems.length} another items present with same seller, Please enter the values to follow up`}</p>
                        <div className="mt-0 px-2 py-1">
                            <div className="flex flex-column flex-wrap py-2 w-full">
                                <div className="flex justify-content-between flex-grow-1 font-bold  header-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px", background: "#ececec" }}>
                                    <div className="mb-2" style={{ width: '2%' }}>
                                        {/* <Checkbox></Checkbox> */}
                                    </div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '14%' }}>Seller PO No.</div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '14%' }}>Product</div>
                                    {/* <div className="mb-2 p-1 align-self-center" style={{ width: '3%' }}>PO Qty</div> */}
                                    <div className={`.custom-tool-tip-product-qty-header mb-2 p-1 align-self-center`} style={{ width: '8%' }}>PO-Rec-Pend</div>
                                    <Tooltip target={`.custom-tool-tip-product-qty-header`} position="top" autoHide={true}>
                                        <p className="m-0">{`PO - Received - Pending`}</p>
                                    </Tooltip>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '10%' }}>Buyer Name</div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '7%' }}>Buyer Del. Date</div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '7%' }}>PM Del. Date</div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '7%' }}>Prev. Remarks</div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '7%' }}>
                                        Updated PM Del. Date
                                        <span style={{ color: "red" }} className="from-required">*</span>
                                    </div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '10%' }}>
                                        FollowUp Status
                                        <span style={{ color: "red" }} className="from-required">*</span>
                                    </div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '7%' }}>
                                        Next FollowUp Date
                                        <span style={{ color: "red" }} className="from-required">*</span>
                                    </div>
                                    <div className="mb-2 p-1 align-self-center" style={{ width: '13%' }}>
                                        Remarks
                                        <span style={{ color: "red" }} className="from-required">*</span>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label>
                                        <CheckboxField
                                            name={'selectAll'}
                                            label={"Select All"}
                                            checked={relatedFollowUpSPOItems.length > 0 ? relatedFollowUpSPOItems.length === bulkUpdateFollowUpSPOItemIds.length : false}
                                            onChange={(event) => handleSelectAllCheckBox(event)}
                                            disabled={relatedFollowUpSPOItems.length === 0}
                                        />
                                    </label>
                                </div>
                                {
                                    otherFollowUpSPOItems.length > 0 &&
                                    <div className='mt-2 w-full'>
                                        {renderFollowUpSPOItems(otherFollowUpSPOItems)}
                                    </div>
                                }
                                {
                                    todayFollowUpSPOItems.length > 0 &&
                                    <div className='mt-2  w-full'>
                                        <span className='mb-0 pt-0 font-bold' style={{ color: "#00baaa", fontSize: "12px" }}>FollowUp Items Today</span>
                                        {renderFollowUpSPOItems(todayFollowUpSPOItems)}
                                    </div>
                                }
                                {
                                    tomorrowFollowUpSPOItems.length > 0 &&
                                    <div className='mt-2  w-full'>
                                        <p className='my-0 pt-0 font-bold' style={{ color: "#00baaa", fontSize: "12px" }}> FollowUp Items Tomorrow</p>
                                        {renderFollowUpSPOItems(tomorrowFollowUpSPOItems)}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="flex justify-content-end mt-4">
                            <Button className="h-2rem  p-2" label="Submit" onClick={() => handleOnClickSubmit()} />
                        </div>
                    </>
                    :
                    <h3 className='text-center mt-3'>No FollowUp Items</h3>
            }

        </div>
    )
}

export default FollowUpSellerPOItems
